import styled from "@emotion/styled";

// eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
export default styled.div`
  &.rich-text-editor {
    position: relative;
    padding: 12px auto;
    overflow-y: visible;

    &.no-toolbar {
      border-top: 1px solid;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }

    &.no-statusbar {
      border-bottom: 1px solid;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    section {
      margin-top: 1em;
      margin-bottom: 1em;
    }

    .text-align-center {
      text-align: center;
    }

    .text-align-justify {
      text-align: justify;
    }

    .text-align-left {
      text-align: left;
    }

    .text-align-right {
      text-align: right;
    }

    .float-left {
      float: left;
    }

    .float-right {
      float: right;
    }

    .indent0 {
      margin-left: 0;
    }

    .indent1 {
      margin-left: 2.5rem;
    }

    .indent2 {
      margin-left: 5rem;
    }

    .indent3 {
      margin-left: 7.5rem;
    }

    .indent4 {
      margin-left: 10rem;
    }

    .indent5 {
      margin-left: 12.5rem;
    }

    .indent6 {
      margin-left: 15rem;
    }

    .indent7 {
      margin-left: 17.5rem;
    }

    .indent8 {
      margin-left: 20rem;
    }

    .indent9 {
      margin-left: 22.5rem;
    }

    .indent10 {
      margin-left: 25rem;
    }

    .indent11 {
      margin-left: 27.5rem;
    }

    .indent12 {
      margin-left: 30rem;
    }

    .indent13 {
      margin-left: 32.5rem;
    }

    .indent14 {
      margin-left: 35rem;
    }

    .indent15 {
      margin-left: 37.5rem;
    }

    .indent16 {
      margin-left: 40rem;
    }

    .indent17 {
      margin-left: 42.5rem;
    }

    .indent18 {
      margin-left: 45rem;
    }

    .indent19 {
      margin-left: 47.5rem;
    }

    .indent20 {
      margin-left: 50rem;
    }
  }

  // 以下、Draft.jsエディタ内でのスタイル打ち消し
  .DraftEditor-editorContainer,
  .DraftEditor-root,
  .public-DraftEditor-content {
    height: inherit;
    text-align: initial;
  }
  .DraftEditor-editorContainer *,
  .DraftEditor-root *,
  .public-DraftEditor-content * {
    font-family: inherit;
  }

  .public-DraftEditor-content[contenteditable="true"] {
    -webkit-user-modify: read-write-plaintext-only;
  }

  .DraftEditor-editorContainer {
    position: relative;
    z-index: 1;
    border-left: none;
  }

  .public-DraftEditor-block {
    position: relative;
  }

  .DraftEditor-alignLeft .public-DraftStyleDefault-block {
    text-align: left;
  }

  .DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {
    left: 0;
    text-align: left;
  }

  .DraftEditor-alignCenter .public-DraftStyleDefault-block {
    text-align: center;
  }

  .DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {
    margin: 0 auto;
    text-align: center;
    width: 100%;
  }

  .DraftEditor-alignRight .public-DraftStyleDefault-block {
    text-align: right;
  }

  .DraftEditor-alignRight .public-DraftEditorPlaceholder-root {
    right: 0;
    text-align: right;
  }

  .public-DraftEditorPlaceholder-root {
    color: #9197a3;
    position: absolute;
    z-index: 1;
  }

  .public-DraftEditorPlaceholder-hasFocus {
    color: #bdc1c9;
  }

  .DraftEditorPlaceholder-hidden {
    display: none;
  }

  .public-DraftStyleDefault-block {
    position: relative;
    white-space: pre-wrap;
  }

  .public-DraftStyleDefault-ltr {
    direction: ltr;
    text-align: inherit;
  }

  .public-DraftStyleDefault-rtl {
    direction: rtl;
    text-align: right;
  }

  .public-DraftStyleDefault-listLTR {
    direction: ltr;
  }

  .public-DraftStyleDefault-listRTL {
    direction: rtl;
  }

  .public-DraftStyleDefault-ol,
  .public-DraftStyleDefault-ul {
    margin: 0;
    padding: 0;
  }

  .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
    margin-left: 2.5rem;
  }

  .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {
    margin-right: 2.5rem;
  }

  .public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {
    margin-left: 4rem;
  }

  .public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {
    margin-right: 4rem;
  }

  .public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {
    margin-left: 5.5rem;
  }

  .public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {
    margin-right: 5.5rem;
  }

  .public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {
    margin-left: 7rem;
  }

  .public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {
    margin-right: 7rem;
  }

  .public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {
    margin-left: 8.5rem;
  }

  .public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {
    margin-right: 8.5rem;
  }

  .public-DraftStyleDefault-unorderedListItem {
    list-style-type: square;
    position: relative;
  }

  .public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {
    list-style-type: disc;
  }

  .public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {
    list-style-type: circle;
  }

  .public-DraftStyleDefault-orderedListItem {
    list-style-type: none;
    position: relative;
  }

  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {
    left: -36px;
    position: absolute;
    text-align: right;
    font-family: inherit;
    font-size: inherit;
    width: 30px;
  }

  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {
    position: absolute;
    right: -36px;
    text-align: left;
    width: 30px;
  }

  .public-DraftStyleDefault-orderedListItem:before {
    content: counter(ol0) ". ";
    counter-increment: ol0;
  }

  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {
    content: counter(ol1, lower-alpha) ") ";
    counter-increment: ol1;
  }

  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {
    content: counter(ol2, lower-roman) ". ";
    counter-increment: ol2;
  }

  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {
    content: counter(ol3, upper-alpha) ". ";
    counter-increment: ol3;
  }

  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {
    content: counter(ol4) ". ";
    counter-increment: ol4;
  }

  .public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {
    counter-reset: ol0;
  }

  .public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {
    counter-reset: ol1;
  }

  .public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {
    counter-reset: ol2;
  }

  .public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {
    counter-reset: ol3;
  }

  .public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {
    counter-reset: ol4;
  }
`;
